export interface IPaginaInfo {
    pagina:number;
    tamanho:number;
    totalRegistros:number;
    totalPaginas:number;
}

export class PaginaInfo implements IPaginaInfo {
    public pagina: number;
    public tamanho: number;
    public totalRegistros: number = 0;
    public totalPaginas: number = 0;

    constructor(pagina?: number, tamanho?: number){
        this.pagina = pagina?? 1;
        this.tamanho = tamanho?? 15;
    }

}

export interface IPagina<TEntidade> extends IPaginaInfo {
    registros:Array<TEntidade>;
}

export default class Pagina<TEntidade> extends PaginaInfo implements IPagina<TEntidade> 
{
    registros: TEntidade[] = [];
}

export const proximaPagina = (page: IPagina<any>): number | null => {
    const proximo = page.pagina + 1;
    if (proximo <= page.totalPaginas) return proximo;
    return null;
};

export const paginaAnterior = (page: IPagina<any>): number | null => {
    const proximo = page.pagina - 1;
    if (proximo >= 0) return proximo;
    return null;
};
